module.exports = "/images/c69eb7ebb54a83d5c0a6fdbe83d576ff.svg";